import BaseComposeView from './BaseComposeView'

export default BaseComposeView
